export const CHANGE_FEATURE_FLAGS_SUCCESS = 'CHANGE_FEATURE_FLAGS_SUCCESS';
export const CHANGE_FEATURE_FLAGS_ERROR = 'CHANGE_FEATURE_FLAGS_ERROR';
